export class CustomTag {
  id: number;
  tag_name: string;
}
